import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  // {
  //   label: 'Home',
  //   icon: 'HomeIcon',
  //   href: '/',
  // },
  // {
  //   label: 'Trade',
  //   icon: 'TradeIcon',
  //   initialOpenState: false,
  //   items: [
  //     {
  //       label: 'Exchange',
  //       href: '/swap',
  //     },
  //     {
  //       label: 'Liquidity',
  //       href: '/pool',
  //     }
  //   ],
  // },
  // {
  //   label: 'SERO',
  //   icon: 'NftIcon',
  //   href: 'https://sero.goer.cloud',
  // },
  {
    label: 'Exchange',
    icon: 'TradeIcon',
    href: '/swap',
  },
  {
    label: 'Liquidity',
    icon: 'NftIcon',
    href: '/pool',
  },
  {
    label: "Info",
    icon: "InfoIcon",
    href: 'https://biaswap.github.io/info/',
  }
]

export default config
